export const COMPLETE_PROFILE_GROUP_LINKS = {
  BASE: "/complete-profile",
  STEP_1: "/complete-profile?step=1",
  STEP_2: "/complete-profile?step=2",
  STEP_3: "/complete-profile?step=3",
  EXTERNAL: {},
};
